module.exports = __webpack_public_path__ + "img/button-hover.6a9dc84f.png";